import { CompanyProjectVisibilityForm } from './CompanyProjectVisibilityForm';

/** Global company settings (project visibility) for /settings/company — same form as Company profile → Settings. */
const GlobalCompanySettingsForm = () => <CompanyProjectVisibilityForm source="team" />;

export default GlobalCompanySettingsForm;
